import Swiper from 'swiper';
import '../css/common/common.css';
import '../css/common/content-wrapper.css';
import '../css/common/banner-wrapper.css';
import '../css/common/pattern-cover.css';
import '../css/common/section-block.css';
import '../css/common/button-effect.css';
import '../css/contact-block.css';

import '../css/nest-menu.css';
import '../css/section-half.css';

import '../../node_modules/swiper/dist/css/swiper.css';
import '../css/swiper-container.css';
import '../css/index/slide-info.css';
import '../css/room/room-information.css';
import '../css/room/note-block.css';

import '../js/importCommonCss';
import setup from './setupCommonJS';
import getThemeDetail from './request/themeDetail';
import { uploadUri } from './appConfig';
import generateFacilitySlide from './index/generateFacilitySlide';
import updateThemeSlideInfo from './theme/updateThemeSlideInfo';
import languageBasedTag from './languageBasedTag';
import hideLoadingImage from './common/hideLoadingImage';

setup();

document.head.appendChild(
	languageBasedTag(),
);

getThemeDetail(window.location.pathname.split('/')[3])
	.then((json) => {
		document.querySelector('.nest-menu > .current').innerText = json.title;
		document.querySelector('.section-half > .content > .title').innerText = json.title;
		document.querySelector('.section-half > .content > .content').innerText = json.content;
		document.querySelector('.section-half > .image').setAttribute(
			'style',
			`background-image: url(${uploadUri}/${json.cover})`,
		);

		json.images.forEach(({ url: image }) => {
			document.querySelector('.swiper-container.-facility > .swiper-wrapper')
				.appendChild(
					generateFacilitySlide(`${uploadUri}/${image}`),
				);
		});

		Swiper('.swiper-container.-facility', {
			pagination: '.swiper-pagination',
			nextButton: '.swiper-button-next',
			prevButton: '.swiper-button-prev',
			paginationClickable: true,
			loop: true,
			onSlideChangeStart: (slide) => updateThemeSlideInfo(json.images[slide.realIndex]),
		});
	})
	.then(() => {
		hideLoadingImage();
	})
	.catch(({ error_msg: errorMsg }) => {
		if (errorMsg === 'NOT_FOUND') {
			window.location.href = 'theme';
		}
	});



// WEBPACK FOOTER //
// ./src/js/themes-info.js